import { Save } from 'lucide-react'

import { Button } from '@/components/ui/button'

interface DashboardSaveButtonProps {
  onSave: () => void
  disabled?: boolean
  isSaving?: boolean
}

export function DashboardSaveButton({ onSave, disabled = false, isSaving = false }: DashboardSaveButtonProps) {
  return (
    <Button
      onClick={onSave}
      disabled={disabled || isSaving}
      className="bg-gradient-to-r from-primary-500 to-primary-600 hover:from-primary-600 hover:to-primary-700 shadow-sm disabled:from-neutral-300 disabled:to-neutral-300"
    >
      <Save className="mr-2 h-4 w-4" />
      {isSaving ? 'Saving...' : 'Save Layout'}
    </Button>
  )
}
